export const selectModelsList = (state) => state.models.models;
export const selectModelsLoading = (state) => state.models.loading;
export const selectModelsError = (state) => state.models.error;
export const selectModelsSuccessMessage = (state) => state.models.successMessage;
